var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-modal',{attrs:{"id":_vm.modalId,"size":"xl","hide-footer":"","body-class":"overflow-auto","centered":"","title":_vm.$t('availability')},on:{"hidden":function($event){return _vm.handleHidden()}}},[_c('EChart',{staticClass:"shadow-none m-0",attrs:{"options":_vm.chartData,"card":""}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }